<template>
  <div>
    <div class="player-nav">
      <ul>
        <li>
          <a href="#" :class="tab === 'away' ? 'on' : ''" @click.prevent="tabClick('away')">{{awayTeamName}}</a>
        </li>
        <li>
          <a href="#" :class="tab === 'home' ? 'on' : ''" @click.prevent="tabClick('home')">{{homeTeamName}}</a>
        </li>
      </ul>
    </div>
    <div class="inner-wrap">
      <div class="title">
        <h2 class="title-area">
          <span class="label">타자 기록</span>
        </h2>
      </div>
      <div class="band-board-content">
        <table>
          <caption>타자 기록표</caption>
          <colgroup>
            <col width="114px">
            <col width="">
            <col width="114px">
            <col width="114px">
            <col width="114px">
            <col width="114px">
            <col width="114px">
            <col width="114px">
            <col width="114px">
            <col width="114px">
          </colgroup>
          <thead>
          <tr>
            <th scope="col">타순</th>
            <th scope="col">선수명</th>
            <th scope="col">타석</th>
            <th scope="col">타수</th>
            <th scope="col">안타</th>
            <th scope="col">타점</th>
            <th scope="col">득점</th>
            <th scope="col">홈런</th>
            <th scope="col">삼진</th>
            <th scope="col">타율</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(hitter, index) in hitterList" :key="index">
            <td>{{oneturn(hitter)}}</td>
            <td>{{pname(hitter)}}</td>
            <td>{{pa(hitter)}}</td>
            <td>{{ab(hitter)}}</td>
            <td>{{hit(hitter)}}</td>
            <td>{{rbi(hitter)}}</td>
            <td>{{run(hitter)}}</td>
            <td>{{hr(hitter)}}</td>
            <td>{{kk(hitter)}}</td>
            <td>{{hra(hitter)}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="inner-wrap">
      <div class="title">
        <h2 class="title-area">
          <span class="label">투수 기록</span>
        </h2>
      </div>
      <div class="band-board-content pitcher-board">
        <table>
          <caption>투수 기록표</caption>
          <colgroup>
            <col width="">
            <col width="126px">
            <col width="126px">
            <col width="126px">
            <col width="126px">
            <col width="126px">
            <col width="126px">
          </colgroup>
          <thead>
          <tr>
            <th scope="col">선수명</th>
            <th scope="col">결과</th>
            <th scope="col">이닝</th>
            <th scope="col">삼진</th>
            <th scope="col">실점</th>
            <th scope="col">자책</th>
            <th scope="col">평균 자책</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(pitcher, index) in pitcherList" :key="index">
            <td>{{pname(pitcher)}}</td>
            <td>{{wls(pitcher)}}</td>
            <td>{{inn(pitcher)}}</td>
            <td>{{kk(pitcher)}}</td>
            <td>{{r(pitcher)}}</td>
            <td>{{er(pitcher)}}</td>
            <td>{{era(pitcher)}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  export default {
    name: 'TeamBatterAndPitcherRecords',
    props: {
      playerStatus: {
        type: Array
      },
      vsScoreResult: {
        type: Object
      }
    },
    data () {
      return {
        tab: 'away'
      }
    },
    computed: {
      homeTeamInfo () {
        return _.get(this.playerStatus, '0', {})
      },
      awayTeamInfo () {
        return _.get(this.playerStatus, '1', {})
      },
      homeTeamName () {
        return _.get(this.vsScoreResult, 'homeTeamName', '')
      },
      awayTeamName () {
        return _.get(this.vsScoreResult, 'awayTeamName', '')
      },
      pitcherList () {
        const teamInfo = this.tab === 'home' ? this.homeTeamInfo : this.awayTeamInfo
        return _.get(teamInfo, 'grids.0.PITCHER', [])
      },
      hitterList () {
        const teamInfo = this.tab === 'home' ? this.homeTeamInfo : this.awayTeamInfo
        return _.get(teamInfo, 'grids.0.HITTER', [])
      }
    },
    methods: {
      teamName (code) {
        switch (code) {
          case 'SK':
            return 'SK'
          case 'OB':
            return '두산'
          case 'WO':
            return '넥센'
          case 'SS':
            return '삼성'
          case 'LG':
            return 'LG'
          case 'LT':
            return '롯데'
          case 'HT':
            return '기아'
          case 'NC':
            return 'NC'
          case 'HH':
            return '한화'
          case 'KT':
            return 'kt'
        }
      },
      tabClick (tab) {
        this.tab = tab
      },
      oneturn (item) {
        return _.get(item, 'oneturn', '')
      },
      pname (item) {
        return _.get(item, 'pname', '')
      },
      pa (item) {
        return _.get(item, 'pa', '')
      },
      ab (item) {
        return _.get(item, 'ab', '')
      },
      hit (item) {
        return _.get(item, 'hit', '')
      },
      rbi (item) {
        return _.get(item, 'rbi', '')
      },
      run (item) {
        return _.get(item, 'rbi', '')
      },
      hr (item) {
        return _.get(item, 'hr', '')
      },
      kk (item) {
        return _.get(item, 'kk', '')
      },
      hra (item) {
        return _.get(item, 'hra', '')
      },
      wls (item) {
        return _.get(item, 'wls', '')
      },
      inn (item) {
        return _.get(item, 'inn', '')
      },
      r (item) {
        return _.get(item, 'r', '')
      },
      er (item) {
        return _.get(item, 'er', '')
      },
      era (item) {
        return _.get(item, 'era', '')
      }
    }
  }
</script>

<style scoped>
  .player-nav + .inner-wrap{
    min-height: 0;
    margin-top: 40px;
  }

  .pitcher-board.band-board-content table th,
  .pitcher-board.band-board-content table td{
    text-align: center;
  }

  .pitcher-board.band-board-content table th:first-child,
  .pitcher-board.band-board-content table td:first-child{
    text-align: left;
  }
</style>
